// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"04a1721b","553":"e0f6ad0c","977":"b49a3bb6"}[chunkId] + ".chunk.js";
};